import { Component, OnInit,ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'environments/environment';
import { AdminService } from '../../../../services/admin';
import { CMSService } from '../../../../services/cms-service';
//import { NgxImageGalleryComponent, GALLERY_IMAGE, GALLERY_CONF } from "ngx-image-gallery";

@Component({
  selector: 'app-imagevideocovid',
  templateUrl: './imagevideocovid.component.html',
  styleUrls: ['./imagevideocovid.component.scss']
})
export class ImagevideocovidComponent implements OnInit {
  titre_epidemie: any ;
  mode_epidemie: number;
  titre: any = "Coronavirus";
  id: any;
  urlInfoIec = environment.urlInfoIec;
  urllogoIec = environment.urllogoIec;
  urlfileIec_ = environment.urlfileIec;
  urlVideoIec = environment.urlVideoIec;
  source_video: any;
  infoIecVideo: any;
  infoIecImage: any;
  urllogoIec__ = environment.urllogoIec +"/cms/covid_fond_5.jpg";



  // //config
  // // get reference to gallery component
  // @ViewChild(NgxImageGalleryComponent) ngxImageGallery: NgxImageGalleryComponent;
  
  // // gallery configuration
  // conf: GALLERY_CONF = {
  //   imageOffset: '0px',
  //   showDeleteControl: false,
  //   showImageTitle: false,
  // };
    
  // // gallery images
  // images: GALLERY_IMAGE[] = [
  //   {
  //     url: "https://images.pexels.com/photos/669013/pexels-photo-669013.jpeg?w=1260", 
  //     altText: 'woman-in-black-blazer-holding-blue-cup', 
  //     title: 'woman-in-black-blazer-holding-blue-cup',
  //     thumbnailUrl: "https://images.pexels.com/photos/669013/pexels-photo-669013.jpeg?w=60"
  //   },
  //   {
  //     url: "https://images.pexels.com/photos/669006/pexels-photo-669006.jpeg?w=1260", 
  //     altText: 'two-woman-standing-on-the-ground-and-staring-at-the-mountain', 
  //     extUrl: 'https://www.pexels.com/photo/two-woman-standing-on-the-ground-and-staring-at-the-mountain-669006/',
  //     thumbnailUrl: "https://images.pexels.com/photos/669006/pexels-photo-669006.jpeg?w=60"
  //   },
  // ];

  
//   <ngx-image-gallery 
// [images]="images" 
// [conf]="conf"
// (onOpen)="galleryOpened($event)"
// (onClose)="galleryClosed()"
// (onImageClicked)="galleryImageClicked($event)"
// (onImageChange)="galleryImageChanged($event)"
// (onDelete)="deleteImage($event)"
// ></ngx-image-gallery>



  
imagesBasic = [
{ img: 'https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(117).jpg', thumb:
'https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(117).jpg', description: 'Image 1' },
{ img: 'https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(98).jpg', thumb:
'https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(98).jpg', description: 'Image 2' },
{ img: 'https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(131).jpg', thumb:
'https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(131).jpg', description: 'Image 3' },
{ img: 'https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(123).jpg', thumb:
'https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(123).jpg', description: 'Image 4' },
{ img: 'https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(118).jpg', thumb:
'https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(118).jpg', description: 'Image 5' },
{ img: 'https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(128).jpg', thumb:
'https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(128).jpg', description: 'Image 6' },
{ img: 'https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(132).jpg', thumb:
'https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(132).jpg', description: 'Image 7' },
{ img: 'https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(115).jpg', thumb:
'https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(115).jpg', description: 'Image 8' },
{ img: 'https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(133).jpg', thumb:
'https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20(133).jpg', description: 'Image 9' }
];

  constructor(public activatedRoute: ActivatedRoute, private adminService: AdminService,public cmsService: CMSService) {
    this.id = activatedRoute.snapshot.params['id'];
    this.source_video = this.adminService.getevolution_default_video();
  }

  

  ngOnInit() {
    if(this.id==1){
      this.getIecVideo();
      this.mode_epidemie = 1;
      this.titre_epidemie ="Video Covid-19"
    }else{
      //image
      this.getIecImage();
      this.mode_epidemie = 2;
      this.titre_epidemie ="Image Covid-19"
    }
  }

  getIecVideo() {
    this.cmsService.getIec("V")
      .subscribe(data => {
        this.infoIecVideo = data
      },
        err => {
          console.log(err);
        })
  }

  getIecImage() {
    this.cmsService.getIecImage("P")
      .subscribe(data => {
        this.infoIecImage = data
      },
        err => {
          console.log(err);
        })
  }







  // // METHODS
  // // open gallery
  // openGallery(index: number = 0) {
  //   this.ngxImageGallery.open(index);
  // }
    
  // // close gallery
  // closeGallery() {
  //   this.ngxImageGallery.close();
  // }
    
  // // set new active(visible) image in gallery
  // newImage(index: number = 0) {
  //   this.ngxImageGallery.setActiveImage(index);
  // }
    
  // // next image in gallery
  // nextImage(index: number = 0) {
  //   this.ngxImageGallery.next();
  // }
    
  // // prev image in gallery
  // prevImage(index: number = 0) {
  //   this.ngxImageGallery.prev();
  // }
    
  // /**************************************************/
    
  // // EVENTS
  // // callback on gallery opened
  // galleryOpened(index) {
  //   console.info('Gallery opened at index ', index);
  // }
 
  // // callback on gallery closed
  // galleryClosed() {
  //   console.info('Gallery closed.');
  // }
 
  // // callback on gallery image clicked
  // galleryImageClicked(index) {
  //   console.info('Gallery image clicked with index ', index);
  // }
  
  // // callback on gallery image changed
  // galleryImageChanged(index) {
  //   console.info('Gallery image changed to index ', index);
  // }
 
  // // callback on user clicked delete button
  // deleteImage(index) {
  //   console.info('Delete image at index ', index);
  // }



}
